import { render, staticRenderFns } from "./scaleLabels.vue?vue&type=template&id=a03b6702&"
import script from "./scaleLabels.vue?vue&type=script&lang=js&"
export * from "./scaleLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports